import { render } from "./AgenceDossier.vue?vue&type=template&id=4117692a"
import script from "./AgenceDossier.vue?vue&type=script&lang=js"
export * from "./AgenceDossier.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__